import { render, staticRenderFns } from "./VaimoSpecialOfferProducts.vue?vue&type=template&id=2a3f2178&scoped=true&"
import script from "./VaimoSpecialOfferProducts.vue?vue&type=script&lang=ts&"
export * from "./VaimoSpecialOfferProducts.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoSpecialOfferProducts.vue?vue&type=style&index=0&id=2a3f2178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f2178",
  null
  
)

export default component.exports